export default {
    updateTemplateOrder(state, { templateId, newOrder }) {
        const template = state.portfolioTemplates.find(t => t.templateId === templateId);
        if (template) {
            template.order = newOrder;
        }
    },
    updatePortfolioTemplates(state, portfolioTemplate) {
        const idx = state.portfolioTemplates.findIndex(template => template.templateId === portfolioTemplate.templateId);
        if (idx !== -1) {
            state.portfolioTemplates.splice(idx, 1, portfolioTemplate);
        } else {
            state.portfolioTemplates.push(portfolioTemplate);
        }
    },
    removePortfolioTemplate(state, portfolioTemplate) {
        const idx = state.portfolioTemplates.findIndex(template => template.templateId === portfolioTemplate.templateId);
        if (idx !== -1) {
            state.portfolioTemplates.splice(idx, 1);
        }
    },
    setPortfolioTemplateStyles(state, styles) {
        state.portfolioTemplateStyles = styles;
    }
}